export const CALENDAR_SET_VIEW = 'CALENDAR_SET_VIEW';
export const CALENDAR_SET_DATE = 'CALENDAR_SET_DATE';
export const CALENDAR_SET_SELECTED_AGENDAS = 'CALENDAR_SET_SELECTED_AGENDAS';
export const CALENDAR_SET_FILTERS = 'CALENDAR_SET_FILTERS';
export const CALENDAR_SET_LOADING = 'CALENDAR_SET_LOADING';
export const CALENDAR_SET_ERROR = 'CALENDAR_SET_ERROR';
export const CALENDAR_CLEAR_ERROR = 'CALENDAR_CLEAR_ERROR';

export const CALENDAR_VIEWS = {
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
  AGENDA: 'agenda'
};

export const APPOINTMENT_STATUS = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
  CANCELED: 'canceled'
};